.tile {
    position: relative;
    border-radius: 8px;
    transition:
        border-color 0.15s cubic-bezier(0.4, 1.2, 0.6, 1),
        box-shadow 0.15s cubic-bezier(0.4, 1.2, 0.6, 1),
        transform 0.15s cubic-bezier(0.4, 1.2, 0.6, 1);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
    padding: 0.875rem;
    min-height: 148px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
}

.tile:hover,
.tile:focus-visible {
    border-color: var(--mantine-color-primary-3);
    box-shadow: 0 4px 16px 0 rgba(132, 94, 247, 0.12);
    transform: translateY(-4px) scale(1.02);
    outline-width: 1px;
    outline-style: solid;
    outline-color: var(--mantine-color-primary-3);
}

.passedBadge .mantine-ActionIcon-root {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
}

.passedBadge .mantine-Text-root {
    font-size: 0.75rem;
    margin-left: 2px;
}

.passedIcon {
    width: 20px;
    height: 20px;
    scale: 0.8;
}

.name {
    flex: 1;
    font-size: 1rem;
    font-weight: 700;
}

.description {
    font-size: 1rem;
    line-height: 1.5rem;
    min-height: 48px;
    max-height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; /* Enables the flexible box layout for line clamping */
    -webkit-line-clamp: 3; /* Truncates after 3 lines (adjust as needed) */
    -webkit-box-orient: vertical; /* Specifies the direction of the box children */
}

.actionsRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}

.retryButton {
    padding: 0 0.8725rem;
    font-size: 0.8725rem;
    font-weight: 400;
    border-radius: 999px;
    background: var(--mantine-color-dark-4);
    box-shadow: none;
    border: none;
    color: var(--mantine-color-dark-1);
    transition: background 0.15s;
    height: 1.5rem;
}

.retryButton:hover,
.retryButton:focus-visible {
    background: var(--mantine-color-dark-3);
    color: var(--mantine-color-dark-1);
}

.viewResultsLink {
    padding: 0 0.8725rem;
    font-size: 0.8725rem;
    font-weight: 400;
    background: none;
    border: none;
    color: var(--mantine-color-dark-1);
    cursor: pointer;
    text-decoration: none;
    transition: color 0.15s;
    height: 1.5rem;
}

.viewResultsLink:hover,
.viewResultsLink:focus-visible {
    color: var(--mantine-color-primary-3);
    text-decoration: underline;
    outline: none;
}
